module.exports = __webpack_public_path__ + "static/img/invite_job_banner.6eac58a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inviteJob/invite_job_banner.png
// module id = Q3/4
// module chunks = 34